module.exports = __webpack_public_path__ + "img/cate.e424f10a.svg";